import { ActivatedRoute, Router } from '@angular/router';

import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@nrwl/environment';
import { ILogin } from '@nrwl/rx-models';

@Injectable({
  providedIn: 'root',
})
export class HealthVuAuthService {
  /** #region Constructor */
  constructor(
    private http: HttpClient,
    private activatedRoute: ActivatedRoute,
    private cookieService: CookieService,
    private router: Router,
  ) {
    this.init();
  }

  /** #endregion */

  public isLoggedIn(): boolean {
    return !!localStorage.getItem(environment.localStorage.token);
  }

  public getToken(): string {
    return localStorage.getItem(environment.localStorage.token) || '';
  }

  public setToken(token) {
    localStorage.setItem(environment.localStorage.token, token);
  }

  public login(user: ILogin): Observable<Object> {
    return this.http.post(`${environment.baseAPIUrlv3}authenticate/patient_gateway/`, user);
  }

  public logout(): void {
    this.clearStorage();
  }

  /**
   * Clear Local stroage data
   */
  public clearStorage(): void {
    localStorage.clear();
    this.cookieService.deleteAll('/');
  }

  /**
   * Logout service to invalidate token
   */
  public logoutUser(delete_all_tokens = false): Observable<Object> {
    return this.http.post(`${environment.baseAPIUrlv3}authenticate/logout/`, {
      delete_all_tokens: delete_all_tokens,
    });
  }

  /**
   * Initilize login using token in query parms
   */
  public init() {
    this.activatedRoute.queryParams.subscribe((res: any) => {
      if (res.token) {
        localStorage.setItem(environment.localStorage.token, res.token);
        this.router.navigate(['/consultation/procedures'], {
          queryParams: { token: null },
        });
      }
    });
  }

  /** Set redirct url */
  public setRedirectUrl(redirectUrl: string) {
    localStorage.setItem(environment.localStorage.redirectUrl, redirectUrl);
  }

  /** Get redirect url */
  public getRedirectUrl(): string {
    return <any>localStorage.getItem(environment.localStorage.redirectUrl);
  }

  /** Get redirect url */
  public removeRedirectUrl(): boolean {
    localStorage.removeItem(environment.localStorage.redirectUrl);
    return true;
  }
}
